<template>
  <div class="toasty" :class="toast.type==='is-danger' ? '' : 'toast'">
    <div class="card message" :class="toast.type">
      <div class="card-header">
        <div class="card-header-title">
          {{ toast.title }}
        </div>
        <button class="card-header-icon delete" aria-label="dismiss" @click="dismissToast"/>
      </div>
      <div class="card-content">
        <p>{{ toast.message }}</p>
      </div>
    </div>
  </div>
</template>
<script>

// import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

export default {
  name: 'ToastView',
  // components: {FontAwesomeIcon},
  props: {
    toast: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      showing: false,
    }
  },
  created() {
    if (this.toast.type !== 'is-danger') {
      setTimeout(() => {
        this.showing = true;
        setTimeout(() => {
          this.dismissToast();
        }, 1000);
      }, 6000);
    }
  },
  methods: {
    dismissToast() {
      // this.$store.commit('toast/clearToast', this.toast.title);
      this.$store.commit('toast/clearToastById', this.toast.id);
    }
  }
}
</script>
<style scoped>
.toast {
  opacity: 0;
  animation: fadeInOut 6s ease-in-out forwards;
}
@keyframes fadeInOut {
    0% {
    opacity: 0;
  }
  16.66% { /* 1s von 6s = 16.66% */
    opacity: 1;
  }
  83.33% { /* 5s von 6s = 83.33% */
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>